import React, { useState,useContext } from "react";
import { IconButton, Stack, Box, Tooltip } from "@mui/material";
//Icons
import { MdDelete } from "react-icons/md";
import { ImKey } from "react-icons/im";
import { TbEdit } from "react-icons/tb";

//Srcs
import "../../Style/actionstyle.scss";
import UpdateSection from "./UpdateSection";
import Delete from "../Include/Delete"
import { DELETE_SECTION } from "../../Schema/Section";
import { AuthContext } from "../../Context/AuthContext";
import { useMutation } from "@apollo/client";

export default function SectionAction({ editData, setRefetch }) {
  //Modal update
  const [openEdit, setOpenEdit] = useState(false);
  const handleOpenEdit = () => setOpenEdit(true);
  const handleCloseEdit = () => setOpenEdit(false);

  //Modal delete
  const [openDel, setOpenDel] = useState(false);
  const handleOpenDel = () => setOpenDel(true);
  const handleCloseDel = () => setOpenDel(false);

  const [loading, setLoading] = useState(false);
  const { setAlert } = useContext(AuthContext);

  // console.log("editData::",editData)

  const [deleteSection] = useMutation(DELETE_SECTION, {
    onCompleted: ({ deleteSection }) => { 
      setLoading(false);
      if (deleteSection?.status === true) {
        setAlert(true, "success", deleteSection?.message);
        handleCloseDel();
        setRefetch();
      } else {
        setAlert(true, "error", deleteSection?.message);
      }
    },
    onError: (error) => {
      console.log(error);
    },
  });

  const handleDelete = () => {
    setLoading(true);
    deleteSection({
      variables: {
        id: editData?._id,
      },
    });
  };

  return (
    <div>
      <Stack direction="row" justifyContent="right">
        <Tooltip title="កែប្រែ" placement="top">
          <IconButton
          onClick={handleOpenEdit}
          >
            <Box className="update-container">
              <TbEdit className="update-icon" />
            </Box>
          </IconButton>
        </Tooltip>
        <Tooltip title="លុប" placement="top">
          <IconButton onClick={handleOpenDel}>
            <Box className="delete-container">
              <MdDelete className="delete-icon" />
            </Box>
          </IconButton>
        </Tooltip>
      </Stack>

      <UpdateSection
        open={openEdit}
        handleClose={handleCloseEdit}
        editData={editData}
        setRefetch={setRefetch}
      />

      
      <Delete
        open={openDel}
        handleClose={handleCloseDel}
        title={"Group"}
        loading={loading}
        handleDelete={handleDelete}
      />
    </div>
  );
}
